import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

interface ProtectedRouteProps {
  children: ReactNode;
}

interface DecodedToken {
  exp?: number;
  [key: string]: unknown;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("jwtToken");

  useEffect(() => {
    if (!token) {
      toast.info("Du må logge inn for å fortsette.");
      navigate("/");
      return;
    }

    try {
      const decoded = jwtDecode<DecodedToken>(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp && decoded.exp < currentTime) {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("user");
        toast.warning("Økten din er utløpt. Logg inn igjen.");
        navigate("/");
        return;
      }
    } catch (err) {
      console.error("Ugyldig token:", err);
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("user");
      toast.error("Feil med innlogging. Logg inn igjen.");
      navigate("/");
      return;
    }
  }, [token, navigate]);

  // If token missing or invalid, show nothing while waiting for redirect
  if (!token) return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp && decoded.exp < currentTime) return null;
  } catch {
    return null;
  }

  // ✅ Valid token → render protected content
  return <>{children}</>;
};

export default ProtectedRoute;
